import { render, staticRenderFns } from "./MyLearningGoals.vue?vue&type=template&id=12ac8694&"
import script from "./MyLearningGoals.vue?vue&type=script&lang=js&"
export * from "./MyLearningGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports